module.exports = __webpack_public_path__ + "static/img/milva.e7b5d72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/milva.png
// module id = NOI3
// module chunks = 0